import '@redirector/front/index.css';

import { ApolloProvider } from '@apollo/client';
import App from '@redirector/front/App';
import { AuthProvider } from '@redirector/front/context/AuthContext';
import { apolloClient } from '@redirector/front/gql/client';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ApolloProvider client={apolloClient}>
      {/* Table state lives in the URL and drives controlled inputs; a
          transition would render a change later than the URL records it,
          so the next edit would read the previous state. */}
      <BrowserRouter useTransitions={false}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </ApolloProvider>
  </StrictMode>,
);
